import * as i from 'io-ts';
export const Finish = i.intersection([
    i.type({ name: i.string }),
    i.partial({ color: i.string, colour: i.string, image: i.string }),
]);
export const compare = (a, b) => (a.name > b.name ? 1 : -1);
